import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@components/moleculs/date-pickers/date-picker';
import { LabeledField } from '@components/moleculs/labeled-field';
import type { FormDatePickerProps } from '@components/organisms/forms/form-date-picker/types';

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
    name,
    isRequired,
    labelProps,
    datePickerProps,
    className,
    onChange,
    ...rest
}) => {
    const { control } = useFormContext();

    if (labelProps?.label) {
        return (
            <LabeledField {...labelProps} isRequired={isRequired} className={className}>
                <Controller
                    {...rest}
                    name={name}
                    control={control}
                    render={({ field, fieldState }) => (
                        <DatePicker
                            {...datePickerProps}
                            {...field}
                            helperText={fieldState.error?.message || rest.helperText}
                            error={!!fieldState.error?.message}
                            onChange={(value) => {
                                field.onChange(value);
                                if (onChange) {
                                    onChange(value);
                                }
                            }}
                        />
                    )}
                />
            </LabeledField>
        );
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <DatePicker
                    {...field}
                    helperText={fieldState.error?.message || rest.helperText}
                    error={!!fieldState.error?.message}
                    className={className}
                    onChange={(value) => {
                        field.onChange(value);
                        if (onChange) {
                            onChange(value);
                        }
                    }}
                />
            )}
        />
    );
};
